import { FormFieldV2 as FormField } from '@/components/custom/erp';
import type { DetailRow } from './hooks/useDetailRows';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
  rows: DetailRow[];
}

export function OtherTab({ formMode, rows }: OtherTabProps) {
  const customer = rows[0]?.ma_kh_data as { customer_code?: string; customer_name?: string } | null | undefined;

  return (
    <div className='flex flex-col gap-2 p-4'>
      <div className='grid grid-cols-[100px,1fr] items-start gap-y-1 sm:grid-cols-[120px,1fr] sm:items-center'>
        <Label className='text-sm font-medium'>Mã đối tượng</Label>
        <div className='flex items-center'>
          <FormField name='ma_kh' type='text' disabled={true} value={customer?.customer_code} />
          <span className='text-sm'>{customer?.customer_name}</span>
        </div>
      </div>

      <div className='grid grid-cols-[100px,1fr] items-start gap-y-1 sm:grid-cols-[120px,1fr] sm:items-center'>
        <Label className='text-sm font-medium'>Kèm theo</Label>
        <FormField name='so_ct_goc' type='number' disabled={formMode === 'view'} />
      </div>

      <div className='grid grid-cols-[100px,1fr] items-start gap-y-1 sm:grid-cols-[120px,1fr] sm:items-center'>
        <Label className='text-sm font-medium'>Chứng từ gốc</Label>
        <FormField name='dien_giai_ct_goc' type='text' disabled={formMode === 'view'} />
      </div>
    </div>
  );
}
